import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    ShowButton,
    EditButton,
    DeleteButton,
    TopToolbar,
    FilterButton,
    CreateButton,
    ExportButton,
    TextInput,
    BooleanInput,
    DateInput,
    useListContext
} from 'react-admin';
import { hotlineBlocklistFields } from '../hotlineBlocklist.model';
import HotlineBlocklistLinkField from './fields/hotlineBlocklistLink.component';
import PhoneNumberField from './fields/phoneNumberField.component';
import HotlineStateField from './fields/hotlineStateField.component';
import NotesField from './fields/notesField.component';
import { DATE_TIME_OPTIONS } from '../../app/app.component';

const ListActions = () => {
    const { total } = useListContext();
    
    return (
        <TopToolbar>
            <FilterButton />
            <CreateButton />
            <ExportButton
                disabled={total === 0}
                label="Export CSV"
            />
        </TopToolbar>
    );
};

const hotlineBlocklistFilters = [
    <TextInput 
        source={hotlineBlocklistFields.phoneNumber} 
        label="Phone Number" 
        alwaysOn 
        placeholder="Search phone numbers..."
    />,
    <BooleanInput 
        source={hotlineBlocklistFields.appliesToTx} 
        label="Texas Hotline"
        defaultValue={null}
    />,
    <BooleanInput 
        source={hotlineBlocklistFields.appliesToTn} 
        label="Tennessee Hotline"
        defaultValue={null}
    />,
    <DateInput 
        source="createdBetween.from" 
        label="Created From"
    />,
    <DateInput 
        source="createdBetween.to" 
        label="Created To"
    />
];

const HotlineBlocklistList = () => {
    return (
        <List 
            title="Hotline Blocklist" 
            sort={{ field: 'id', order: 'DESC' }} 
            actions={<ListActions />}
            filters={hotlineBlocklistFilters}
            perPage={25}
        >
            <Datagrid rowClick="show" bulkActionButtons={false}>
                <HotlineBlocklistLinkField label="ID" source={hotlineBlocklistFields.id}/>
                <PhoneNumberField label="Phone Number" source={hotlineBlocklistFields.phoneNumber}/>
                <HotlineStateField label="Applies To" />
                <NotesField label="Notes" source={hotlineBlocklistFields.notes} maxLength={40}/>
                <DateField 
                    source={hotlineBlocklistFields.createdAt} 
                    label="Created At"
                    options={DATE_TIME_OPTIONS}
                />
                <ShowButton />
                <EditButton />
                <DeleteButton 
                    mutationMode="pessimistic"
                    confirmTitle="Delete Phone Number from Blocklist"
                    confirmContent="Are you sure you want to remove this phone number from the hotline blocklist? This action cannot be undone."
                />
            </Datagrid>
        </List>
    );
};

export default HotlineBlocklistList; 